import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore'

export default function Corporateguest() {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
    });

    const [userData, setUserData] = useState();
    const [corporates, setcorporates] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [guest_name, setguest_name] = useState("");
    const [mobile, setmobile] = useState("");
    const [address, setaddress] = useState("");
    const [description, setdescription] = useState("");

    const [updocid, setupdocid] = useState("");
    const [upguest_name, setupguest_name] = useState("");
    const [upmobile, setupmobile] = useState("");
    const [upaddress, setupaddress] = useState("");
    const [updescription, setupdescription] = useState("");

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData();
        });
    }, []);

    const fetchData = () => {

        const q = query(collection(db, 'corporateguests'), orderBy('createdAt', 'asc'))

        onSnapshot(q, (querySnapshot) => {

            const data = querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            }));

            if (searchText === "") {
                setcorporates(data);
            } else {
                const filtered = data.filter(item =>
                    item.data.guest_name.toUpperCase().includes(searchText.toUpperCase())
                );
                setcorporates(filtered);
            }

        });

    }

    const handleSubmit = async () => {

        if (!guest_name) {
            Toast.fire({ icon: "error", title: "Enter Guest Name" })
            return;
        }

        await addDoc(collection(db, "corporateguests"), {
            guest_name,
            mobile,
            address,
            description,
            uid: userData.uid,
            createdAt: Timestamp.now(),
        });

        setguest_name("");
        setmobile("");
        setaddress("");
        setdescription("");

        Toast.fire({
            icon: "success",
            title: 'Corporate Guest Added'
        });
    }

    const handleDelete = async (docid) => {

        await deleteDoc(doc(db, 'corporateguests', docid))

        Toast.fire({
            icon: "success",
            title: 'Deleted Successfully'
        });

    }

    const handleEdit = (id, name, mobile, address, description) => {

        setupdocid(id);
        setupguest_name(name);
        setupmobile(mobile);
        setupaddress(address);
        setupdescription(description);

    }

    const handleUpdate = async () => {

        await updateDoc(doc(db, "corporateguests", updocid), {
            guest_name: upguest_name,
            mobile: upmobile,
            address: upaddress,
            description: updescription
        });

        Toast.fire({
            icon: "success",
            title: 'Updated Successfully'
        });

    }

    return (
        <div>

            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">

                        <button className="btn btn-secondary" style={{ float: "right" }}>
                            || Corporate Guest Mgmt ||
                        </button>

                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">
                            Add Corporate Guest
                        </button>

                        <br /><br />

                        <div className="card card-primary card-outline">

                            <div className="p-2">
                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4'
                                    placeholder='Search Guest...'
                                />
                            </div>

                            <div className="card-body table-responsive p-0">

                                <table className="table table-bordered table-hover table-striped">

                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Guest Name</th>
                                            <th>Mobile</th>
                                            <th>Address</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {corporates.map((item, index) => (

                                            <tr key={item.id}>

                                                <td>{index + 1}</td>
                                                <td>{item.data.guest_name}</td>
                                                <td>{item.data.mobile}</td>
                                                <td>{item.data.address}</td>
                                                <td>{item.data.description}</td>

                                                <td>

                                                    <button
                                                        onClick={() => handleEdit(
                                                            item.id,
                                                            item.data.guest_name,
                                                            item.data.mobile,
                                                            item.data.address,
                                                            item.data.description
                                                        )}
                                                        className="btn btn-sm btn-success"
                                                        data-toggle="modal"
                                                        data-target="#edit-modal"
                                                    >
                                                        Edit
                                                    </button>

                                                    &nbsp;

                                                    <button
                                                        onClick={() => {
                                                            if (window.confirm("Delete this guest?"))
                                                                handleDelete(item.id)
                                                        }}
                                                        className="btn btn-sm btn-danger"
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))}

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>
                </section>
            </div>

            {/* ADD MODAL */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">

                    <div className="modal-content">

                        <div className="modal-header">
                            <h4>Add Corporate Guest</h4>
                        </div>

                        <div className="modal-body">

                            <input placeholder="Guest Name"
                                value={guest_name}
                                onChange={(e) => setguest_name(e.target.value)}
                                className="form-control mb-2" />

                            <input placeholder="Mobile"
                                value={mobile}
                                onChange={(e) => setmobile(e.target.value)}
                                className="form-control mb-2" />

                            <input placeholder="Address"
                                value={address}
                                onChange={(e) => setaddress(e.target.value)}
                                className="form-control mb-2" />

                            <textarea placeholder="Description"
                                value={description}
                                onChange={(e) => setdescription(e.target.value)}
                                className="form-control mb-2" />

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
                                Save
                            </button>
                            <button className="btn btn-danger" data-dismiss="modal">
                                Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>


            {/* EDIT MODAL */}

            <div className="modal fade" id="edit-modal">
                <div className="modal-dialog modal-lg">

                    <div className="modal-content">

                        <div className="modal-header">
                            <h4>Edit Corporate Guest</h4>
                        </div>

                        <div className="modal-body">

                            <input value={upguest_name}
                                onChange={(e) => setupguest_name(e.target.value)}
                                className="form-control mb-2" />

                            <input value={upmobile}
                                onChange={(e) => setupmobile(e.target.value)}
                                className="form-control mb-2" />

                            <input value={upaddress}
                                onChange={(e) => setupaddress(e.target.value)}
                                className="form-control mb-2" />

                            <textarea value={updescription}
                                onChange={(e) => setupdescription(e.target.value)}
                                className="form-control mb-2" />

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-primary" data-dismiss="modal" onClick={handleUpdate}>
                                Update
                            </button>
                            <button className="btn btn-danger" data-dismiss="modal">
                                Close
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}